<template>
    <div
      class="border border-gray-300 bg-white shadow-lg rounded-lg h-[40rem] overflow-y-auto w-[70rem]"
    >
 </div>
</template>
  
  <script>
  
  
  export default {
    components: {
  
    },
    
    props: {
    
    },
    data() {
      return {
    }
    },
    computed: {
     
    },
    methods: {
    },
    mounted() {
     
    }
  };
  </script>
  
  <style scoped>

  </style>